// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-348a9628] .el-dialog__header {\n  background-color: #ffffff;\n  border-bottom: none !important;\n}\n.info[data-v-348a9628] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
